import './uploadData.css'
import React, { useContext, useState, useRef, useEffect } from 'react'
import { UploadDataContext } from '../../context/uploadDataContext/UploadDataContext'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import { AuthContext } from '../../context/authContext/AuthContext'
import { useHistory } from 'react-router-dom'
import Papa from 'papaparse'
import {
  Container,
  Grow,
  Grid,
  Typography,
  FormControl,
  Button,
  Paper
} from '@material-ui/core'
import FileUploadIcon from '@mui/icons-material/FileUpload'
const initialState = {
  name: '',
  email: '',
  password: '',
  isAdmin: false,
  isStudent: false
}
export default function UploadData() {
  const history = useHistory()
  const {
    uploadDataState: { data },
    uploadData
  } = useContext(UploadDataContext)
  const [values, setValues] = useState([])

  const [values2, setValues2] = useState([])

  const [fileClick, setFileClick] = useState([])
  const [fileRevenue, setFileRevenue] = useState([])

  const handleSubmit = async () => {
    if (fileClick.name && fileRevenue.name) {
      uploadData(values, values2)
      history.push(process.env.PUBLIC_URL + '/dashboard')
      alert('File Uploaded Successfully!')
    } else {
      alert('Please Upload 2 csv files!')
      return
    }
  }

  const hiddenFileInput = useRef(null) // ADDED
  const hiddenFileInput2 = useRef(null) // ADDED

  const file1HandleClick = () => {
    hiddenFileInput.current.click() // ADDED
  }
  const file1HandleChange = (event) => {
    const fileUploaded = event.target.files[0] // ADDED
    setFileClick(fileUploaded)
    Papa.parse(fileUploaded, {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        const rowsArray = []
        const valuesArray = []

        // Iterating data to get column name and their values
        results.data.map((d) => {
          rowsArray.push(Object.keys(d))
          valuesArray.push(Object.values(d))
        })

        setValues(valuesArray)
      }
    })
  }

  const file2HandleClick = () => {
    hiddenFileInput2.current.click() // ADDED
  }
  const file2HandleChange = (event) => {
    const fileUploaded = event.target.files[0] // ADDED

    setFileRevenue(fileUploaded)
    Papa.parse(fileUploaded, {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        const rowsArray = []
        const valuesArray = []

        // Iterating data to get column name and their values
        results.data.map((d) => {
          rowsArray.push(Object.keys(d))
          valuesArray.push(Object.values(d))
        })

        // Parsed Data Response in array format
        // setParsedData2(results.data)

        // Filtered Column Names
        // setTableRows2(rowsArray[0])

        // Filtered Values
        setValues2(valuesArray)
      }
    })
  }
  useEffect(() => {
    // console.log(fileRevenue)
  }, [values, values2])
  return (
    <Grow in>
      <Container style={{ marginTop: '50px' }}>
        <Grid
          container
          justifyContent='space-between'
          alignItems='stretch'
          spacing={3}
          className='wrapper'
        >
          <Grid item xs={12} sm={12}>
            <div className='uploadData'>
              <Typography
                className='heading'
                variant='h6'
                style={{ fontWeight: '300', fontSize: '15px' }}
              >
                Upload Performance Data
              </Typography>
              <form
                encType='multipart/form-data'
                autoComplete='off'
                noValidate
                className='formUploadData'
              >
                <Paper className='UploadDataWrapper'>
                  <FormControl fullWidth className='formControl'>
                    <Typography
                      className='heading'
                      variant='h6'
                      style={{ fontWeight: '300', fontSize: '15px' }}
                    >
                      Step 1: Upload influencer Clicks CSV
                    </Typography>
                    <div className='wrapUploadInput'>
                      <div className='fileInput'>
                        <Button onClick={() => file1HandleClick()}>
                          <FileUploadIcon />
                        </Button>
                        <input
                          style={{ display: 'none' }}
                          type='file'
                          ref={hiddenFileInput}
                          onChange={(e) => file1HandleChange(e)}
                          className='formControlFile'
                          name='file1'
                          // onChange={(e) => MultipleFileChange(e)}
                        />
                      </div>
                    </div>
                  </FormControl>
                  <FormControl fullWidth className='formControl'>
                    <Typography
                      className='heading'
                      variant='h6'
                      style={{ fontWeight: '300', fontSize: '15px' }}
                    >
                      Step 2: Upload influencer Revenue CSV
                    </Typography>
                    <div className='wrapUploadInput'>
                      <div className='fileInput'>
                        <Button onClick={() => file2HandleClick()}>
                          <FileUploadIcon />
                        </Button>
                        <input
                          style={{ display: 'none' }}
                          type='file'
                          ref={hiddenFileInput2}
                          onChange={(e) => file2HandleChange(e)}
                          className='formControlFile'
                          name='file2'
                          // onChange={(e) => MultipleFileChange(e)}
                        />
                      </div>
                    </div>
                  </FormControl>
                  <FormControl
                    style={{
                      display:
                        fileClick.name || fileRevenue.name ? 'block' : 'none'
                    }}
                    className='formControl fileUploaded'
                    fullWidth
                  >
                    <Typography
                      className='heading'
                      variant='h6'
                      style={{ fontWeight: '300', fontSize: '15px' }}
                    >
                      Files: <UploadFileIcon />
                      {fileClick && fileClick.name
                        ? `${fileClick.name}`
                        : ''}{' '}
                      {fileRevenue && fileRevenue.name
                        ? `${fileRevenue.name}`
                        : ''}
                    </Typography>
                  </FormControl>

                  <FormControl className='formControl' fullWidth>
                    <Button
                      className='buttonSubmit'
                      variant='contained'
                      color='primary'
                      size='large'
                      type='button'
                      fullWidth
                      // onClick={handleSignUp}
                      // disabled={isFetching}
                      onClick={() => handleSubmit()}
                    >
                      Process Files
                    </Button>
                  </FormControl>
                </Paper>
              </form>
            </div>
          </Grid>
        </Grid>
      </Container>
    </Grow>
  )
}
